import './Promo.scss';
import Component from './Promo.js';
export default Component;
